export default {"src":"/_next/static/media/powerUpSolid_40.082e7dc8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};